import React, { Component } from 'react';
import { shape, string, number, oneOfType, bool } from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

export default class WebTableSummary extends Component {
  static propTypes = {
    isNewAdUserSelected: bool,
    summaryData: shape({
      title: string,
      totalVisits: number,
      // totalUsers: number,
      totalAdVisits: number,
      // totalAdUsers: number,
      totalNewAdUsers: number,
      totalAds: number,
      avgAdCost: oneOfType([number, string]),
      campaignAvgAdCost: number
    })
  }

  render() {
    // const { title, totalVisits, totalUsers, totalAdVisits, totalAdUsers, totalAds, avgAdCost } = this.props.summaryData;
    const { title, totalVisits, totalAdVisits, totalAds, totalVisitsPerAd, campaignAvgAdCost, totalNewAdUsers, totalNewAdUsersPerAds } = this.props.summaryData;
    const { isNewAdUserSelected } = this.props;
    const formattedTotalAdVisits = Math.round(totalAdVisits);
    const formattedTotalNewAdUsers = Math.round(totalNewAdUsers);
    return(
      <div className={classNames(styles.tableRow, styles.summaryRow)}>
        <div data-test="summaryTitle" className={classNames(styles.tableCell, styles.summaryCellTitle)}>{title}</div>
        <div data-test="summaryVisits" className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(totalVisits.toFixed(1)).toLocaleString()}</div>
        {/* <div className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(totalUsers.toFixed(1)).toLocaleString()}</div> */}
        {isNewAdUserSelected 
          ? <div data-test="summaryNewAdUsers" className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(formattedTotalNewAdUsers).toLocaleString()}</div>
          : <div data-test="summaryAdVisits" className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(formattedTotalAdVisits).toLocaleString()}</div>
        }
        {/* <div className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(totalAdUsers.toFixed(1)).toLocaleString()}</div> */}
        <div data-test="summaryAds" className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(totalAds.toFixed(1)).toLocaleString()}</div>
        {isNewAdUserSelected 
          ? <div data-test="summaryNewAdUsersPerAds" className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(totalNewAdUsersPerAds.toFixed(2)).toLocaleString()}</div>
          : <div data-test="summaryVisitsAds" className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(totalVisitsPerAd.toFixed(2)).toLocaleString()}</div>
        }
        {campaignAvgAdCost != null && <div data-test="summaryAdCost" className={classNames(styles.tableCell, styles.summaryCell)}>{`$${parseFloat(campaignAvgAdCost.toFixed(2)).toLocaleString()}`}</div>}
      </div>
    )
  }
}